// extracted by mini-css-extract-plugin
export var actions = "ChangeTargetMsisdn-module--actions--037ce";
export var content = "ChangeTargetMsisdn-module--content--85f1a";
export var deleteButton = "ChangeTargetMsisdn-module--deleteButton--89512";